import styled from 'styled-components';

export const SpinnerWrapperStyled = styled.div`
  min-height: 40rem;
  position: relative;
`;
